<template>
  <div>
    <px-view-header title="Contratações de frete" :breadcrumbs="breadcrumbs"/>
    <div class="mt-5">
      <listagem-contratacao-frete-header :on-click-refresh="onClickRefresh"
                                         is-comprador
                                         @change="onChangeFilter"/>
      <lista-contratacao-frete :contratacoes="contratacoes"
                               :loading="loading"
                               :on-change-options="onChangeOptions"
                               :options-list="optionsList"
                               :footer-options="footerOptions"
                               @update="onClickRefresh"/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-contratacao-frete/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import ContratacaoFreteService from '../contratacao-frete-service';
import ListaContratacaoFrete from './ListaContratacaoFrete.vue';
import ListagemContratacaoFreteHeader from './ListagemContratacaoFreteHeader.vue';

export default {
  mixins: [paginationMixin],
  props: {
    isComprador: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      contratacoes: {
        content: [],
        total: 0,
      },
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de frete' },
        { text: 'Contratações de frete' },
      ],
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemContratacaoFrete', ['stringFilter', 'listOptions']),
    ...mapGetters('user', ['user']),
    ...mapGetters('entidade', ['idEntidade']),
  },
  methods: {
    ...mapActions('listagemContratacaoFrete', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getContratacoes();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getContratacoes();
    },
    onClickRefresh() {
      this.getContratacoes();
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getContratacoes() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return ContratacaoFreteService.getConstratacoes({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.contratacoes = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    ListaContratacaoFrete,
    ListagemContratacaoFreteHeader,
  },
};
</script>
